export enum PercentFluctuationsTypesEnum {
  PERIOD_DEPENDENT = 'periodDependent',
  ADD_OR_REMOVE = 'addOrRemove',
}

export enum PeriodDependentEnum {
  PERIOD_END = 'periodEnd',
  MONTH_PAYING = 'monthPaying',
  MONTH_CAPITALING = 'monthCapitaling',
}

export enum AddOrRemoveEnum {
  ADD = 'add',
  REMOVE = 'remove',
  ADD_AND_REMOVE = 'addAndRemove',
}
